<template>
    <div id="app" :class="this.$store.state.nightMode ? 'dark' : ''">
        <InfoModal
            v-if="showInfoModal"
            v-on:close="closeInfomationModal()"
            :info="infoModalText"
            :isApplication="isApplication"
            :applicationType="applicationType"
            :applicationURL="applicationURL"
        />

        <LocationCityModal v-if="isShowLocationCityModal"
                           v-on:close="closeLocationCityModal"
                           :changeLocationCity="changeLocationCity"
                           :locationCities="locationCities"
                           :isApplication="isApplication"
                           :applicationType="applicationType"
                           :applicationURL="applicationURL"
        />

        <div v-if="mobNav">
            <div class="mob-nav-overlay" @click="closeMobNav()"></div>
            <div class="mob-nav">
                <div style="font-weight: bold;font-size: 1.4rem;padding-left: 14px;padding-right: 14px;">
                    <div style="text-align: left;margin-right: 14px;">
                        <ul style="list-style: none;padding: 0;font-weight: bold;">
                            <li style="cursor: pointer;margin-bottom: 4px;" @click="routerToRoute('pizza')">Головна</li>
                            <li style="cursor: pointer;margin-bottom: 4px;" @click="routerToRoute('delivery-map')">Мапа доставки</li>
                            <li style="cursor: pointer;margin-bottom: 4px;" @click="routerToRoute('about-us')">Про нас</li>
                            <li style="cursor: pointer;margin-bottom: 4px;" @click="routerToRoute('offer')">Угода
                                користувача
                            </li>
                            <li style="cursor: pointer;margin-bottom: 4px;" @click="routerToRoute('cooperation')">
                                Співпраця
                            </li>
                        </ul>
                    </div>
                </div>
                <div style="
padding: 10px 0 4px;
font-size: 1.2rem;
font-weight: bold;
">
                    Завантажуй додаток:
                </div>
                <div style="display: flex; justify-content: center; gap: 4px">
                    <a href="https://apps.apple.com/cy/app/black-pizza/id1498371417" target="_blank" rel="nofollow"
                       aria-label="App Store" style="display: inline-block; margin: 4px 0 4px 4px"
                       onclick="dataLayer.push({'event': 'clickAppStore'});">
                        <img src="@/assets/appstore.webp" style="width: 120px;" alt="App Store" title="App Store">
                    </a>

                    <a href="https://play.google.com/store/apps/details?id=com.oakmont.blackpizza" target="_blank"
                       rel="nofollow" aria-label="Google Play" style="display: inline-block; margin: 4px 0 4px 4px"
                       onclick="dataLayer.push({'event': 'clickGooglePlay'});">
                        <img src="@/assets/googleplay.webp" style="width: 120px;" alt="Google Play" title="Google Play">
                    </a>
                </div>

                <div class="night-mode-checkbox" style="display: flex; justify-content: center;margin-top: 26px">
                    <input type="checkbox" class="checkbox" id="toggleBtn" @change="changeMode" v-model="!!this.$store.state.nightMode"/>
                    <label class="switch" for="toggleBtn">
                        <inline-svg src="/img/icons/sun.svg" class="icon fa-sun" width="25" height="25" ></inline-svg>
                        <inline-svg src="/img/icons/moon.svg" class="icon fa-moon" width="25" height="25"></inline-svg>
                        <div class="ball"></div>
                    </label>
                </div>
            </div>
        </div>

        <div class="main-overlay" id="main-overlay" ref="main-overlay"></div>
        <header>
            <div style="display: flex;justify-content: space-between;width: 100%;align-items: center;">
                <div class="info-section-mobile">
                    <div style="margin-right: 14px; display: flex; align-items: center; justify-content: center">
                        <inline-svg v-if="!mobNav" @click="showMobNav()" src="/img/icons/hamburger-menu.svg" width="25" height="25" :stroke="this.$store.state.nightMode ? 'white' : 'black'"></inline-svg>

                        <inline-svg v-if="mobNav" @click="closeMobNav()" src="/img/icons/close-box.svg" width="25" height="25" :fill="this.$store.state.nightMode ? 'white' : 'black'"></inline-svg>
                    </div>

                    <router-link :to="{name: 'pizza', params: {locationCity: this.$route.params.locationCity}}" :params="{ locationCity: this.$route.params.locationCity }" v-if="!this.$store.state.nightMode">
                        <img src="@/assets/logo_site.webp" class="logo-image" style="width: 250px;">
                        <img src="@/assets/logo_site_mob.webp" class="logo-image-mobile" style="width: 36px;">
                    </router-link>

                    <router-link :to="{name: 'pizza', params: {locationCity: this.$route.params.locationCity}}" :params="{ locationCity: this.$route.params.locationCity }" v-if="this.$store.state.nightMode">
                        <img src="@/assets/logo_site_white.webp" class="logo-image" style="width: 250px;">
                        <img src="@/assets/logo_symbol_white.webp" class="logo-image-mobile" style="width: 36px;">
                    </router-link>
                </div>

                <div style="display: flex;align-items: center;">
                    <div class="info-section">
                        <router-link :to="{name: 'pizza', params: {locationCity: this.$route.params.locationCity}}" :params="{ locationCity: this.$route.params.locationCity }" v-if="!this.$store.state.nightMode">
                            <img src="@/assets/logo_site.webp" class="logo-image" style="width: 250px;">
                            <img src="@/assets/logo_site_mob.webp" class="logo-image-mobile" style="width: 61px;">
                        </router-link>

                        <router-link :to="{name: 'pizza', params: {locationCity: this.$route.params.locationCity}}" :params="{ locationCity: this.$route.params.locationCity }" v-if="this.$store.state.nightMode">
                            <img src="@/assets/logo_site_white.webp" class="logo-image" style="width: 250px;">
                            <img src="@/assets/logo_symbol_white.webp" class="logo-image-mobile" style="width: 61px;">
                        </router-link>

                        <div style="display: flex;margin-right: 14px; margin-left: 14px"
                             onClick="window.open('https://www.instagram.com/black_pizza/')">
                            <inline-svg src="/img/icons/instagram.svg" width="25" height="25"
                                        fill="#AB2321"></inline-svg>
                            <div style="margin-left: 7px;">
                                <span style="font-weight: bold;">/black_pizza</span>
                            </div>
                        </div>

                        <div style="display: flex;margin-right: 14px;cursor: pointer" @click="showLocationCityModal()">
                            <inline-svg src="/img/icons/map-point.svg" width="25" height="25" stroke="#AB2321"></inline-svg>
                            <div style="margin-left: 7px;">
                                <span style="font-weight: bold;">{{ this.$store.state.address }}</span>
                            </div>
                        </div>

                        <div style="margin-right: 14px;display: flex;">
                            <inline-svg src="/img/icons/phone-2.svg" width="25" height="25" stroke="#AB2321"></inline-svg>
                            <div style="margin-left: 7px;font-weight: bold;">{{ this.$store.state.phone }}</div>
                        </div>

                        <div style="display: flex;margin-right: 14px;">
                            <inline-svg src="/img/icons/clock.svg" width="25" height="25"
                                        fill="#AB2321"></inline-svg>
                            <div style="margin-left: 7px;">
                                <span style="font-weight: bold;">11:00-22:00</span>
                            </div>
                        </div>

                        <div class="night-mode-checkbox">
                            <input type="checkbox" class="checkbox" id="toggleBtn" @change="changeMode" v-model="!!this.$store.state.nightMode"/>
                            <label class="switch" for="toggleBtn">
                                <inline-svg src="/img/icons/sun.svg" class="icon fa-sun" width="25" height="25" ></inline-svg>
                                <inline-svg src="/img/icons/moon.svg" class="icon fa-moon" width="25" height="25"></inline-svg>
                                <div class="ball"></div>
                            </label>
                        </div>
                    </div>
                </div>

                <div class="info-section-mobile">
                    <div style="margin-right: 14px" @click="showLocationCityModal()">
                        <inline-svg src="/img/icons/map-point.svg" width="25" height="25" :stroke="this.$store.state.nightMode ? 'white' : 'black'"></inline-svg>
                        <b style="margin-left: 4px">{{ 'м. ' + this.selectedLocationCity.name }}</b>
                    </div>
                </div>

                <div class="info-section-mobile">
                    <div style="margin-right: 14px">
                        <a :href="'tel:' + this.$store.state.phone">
                            <inline-svg src="/img/icons/phone-2.svg" width="30" height="30" :stroke="this.$store.state.nightMode ? 'white' : 'black'" @click="showInfomationModal('phone')"></inline-svg>
                        </a>
                    </div>

                    <div class="cart-section-mobile" style="position: relative">
                        <router-link :to="{name: 'cart'}" :params="{ locationCity: this.$route.params.locationCity }" >
                            <inline-svg src="/img/icons/shopping-cart.svg" width="34" height="34"
                                        :fill="this.$store.state.nightMode ? 'white' : 'black'"></inline-svg>
                            <div v-if="$store.state.cart.length > 0" class="cart-badge">{{ $store.state.cart.length }}</div>
                        </router-link>
                    </div>
                </div>
            </div>
        </header>

        <div class="left-menu" @mouseover="mouseOverLeftMenu" @mouseleave="mouseLeaveLeftMenu">
            <div v-for="category in categories" :key="category.id"  v-if="category.is_enabled == 1 && !category.parent_id" class="left-menu-element" :class="{'is-active': ($route.name == 'category.index' && $route.params.code === category.code) || ($route.name == 'pizza' && category.id == 1)}" @click="routerToCategoryRoute('category.index', category.code)">
                <div>
                    <inline-svg v-if="($route.name == 'category.index' && $route.params.code === category.code) || ($route.name == 'pizza' && category.id == 1)" :src="'/img/icons/categories/' + category.code + '-colored.svg'" width="40" height="40"></inline-svg>

                    <inline-svg v-if="($route.name != 'category.index' && $route.name != 'pizza') || ($route.name == 'category.index' && $route.params.code !== category.code) || ($route.name == 'pizza' && category.id != 1)" :src="'/img/icons/categories/' + category.code + '.svg'" width="40" height="40"
                                :fill="$store.state.nightMode ? 'white' : 'black'"></inline-svg>
                </div>
                <div class="left-menu-element-text">
                    {{ category.name }}
                </div>
            </div>
        </div>

        <div class="main-container" id="main-container">
            <div v-if="$route.name == 'pizza' || ($route.name == 'category.index' && $route.params.code == 'pizza')" class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <img src="@/assets/baner1_large.webp" class="slider-image">
                        <div class="slider-text-section">
                            <h1>
                                Наші переваги
                            </h1>
                            <div class="slider-text-box-description">
                                <div>
                                    Безкоштовна доставка
                                </div>
                                <div>
                                    Кешбек у мобільному додатку
                                </div>
                                <div>
                                    Фірмовий соус у подарунок
                                </div>
                                <div>
                                    Знижка 7% на самовиніс
                                </div>
                                <div class="slide-text-box-button-section">
                                    <a href="#main-content" v-smooth-scroll="{ offset: -80, updateHistory: false }">
                                        <button class="add-to-card-button">Замовити</button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <img src="@/assets/baner2_large.webp" class="slider-image">
                        <div class="slider-text-section">
                            <h1>
                                Любиш поїсти?
                                Велика компанія?
                            </h1>
                            <div class="slider-text-box-description">
                                <div>
                                    Замовляй три піци –
                                    отримуй 50% знижки на четверту!
                                </div>
                                <div class="slide-text-box-button-section">
                                    <a href="#main-content" v-smooth-scroll="{ offset: -80, updateHistory: false }">
                                        <button class="add-to-card-button">Замовити</button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <img src="@/assets/baner3_large.webp" class="slider-image">
                        <div class="slider-text-section">
                            <h1>
                                Приємний бонус!
                            </h1>
                            <div class="slider-text-box-description">
                                <div>
                                    Купуй дві піци –
                                    отримуй 1 л напою у подарунок!
                                </div>
                                <div class="slide-text-box-button-section">
                                    <a href="#main-content" v-smooth-scroll="{ offset: -80, updateHistory: false }">
                                        <button class="add-to-card-button">Замовити</button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination"></div>
            </div>

            <div style="padding: 14px;" id="main-content">
                <router-view/>
            </div>
            <footer class="footer">
                <div class="footer__column">
                    <img v-if="this.$store.state.nightMode" src="@/assets/logo_site_white.webp" style="width: 250px;">
                    <img v-if="!this.$store.state.nightMode" src="@/assets/logo_site.webp" style="width: 250px;">

                    <div class="footer__logo-text">
                        Мабуть, найкраща піцерія у світі ;)
                    </div>

                    <div class="footer__all-rights">
                        Усi права захищенi ©{{ new Date().getFullYear() }} Black Pizza®
                    </div>
                </div>

                <div class="footer__column">
                    <div style="margin-right: 14px" @click="showLocationCityModal()">
                        <inline-svg src="/img/icons/map-point.svg" width="25" height="25" stroke="#AB2321"></inline-svg>
                        <b style="margin-left: 4px">{{ this.$store.state.address }}</b>
                    </div>


                    <div style="margin-right: 14px;display: flex;">
                        <inline-svg src="/img/icons/phone-2.svg" width="25" height="25" stroke="#AB2321"></inline-svg>
                        <div style="margin-left: 7px;font-weight: bold;">{{ this.$store.state.phone }}</div>
                    </div>

                    <div style="display: flex;margin-right: 14px;">
                        <inline-svg src="/img/icons/clock.svg" width="25" height="25"
                                    fill="#AB2321"></inline-svg>
                        <div style="margin-left: 7px;">
                            <span style="font-weight: bold;">11:00-22:00</span>
                        </div>
                    </div>
                </div>

                <div class="footer__column">
                    <ul style="list-style: none;padding: 0;font-weight: bold;margin-bottom: 0">
                        <li style="cursor: pointer;margin-bottom: 4px;" @click="routerToRoute('pizza')">Головна</li>
                        <li style="cursor: pointer;margin-bottom: 4px;" @click="routerToRoute('delivery-map')">Мапа доставки</li>
                        <li style="cursor: pointer;margin-bottom: 4px;" @click="routerToRoute('about-us')">Про нас</li>
                        <li style="cursor: pointer;margin-bottom: 4px;" @click="routerToRoute('offer')">Угода
                            користувача
                        </li>
                        <li style="cursor: pointer;margin-bottom: 4px;" @click="routerToRoute('cooperation')">
                            Співпраця
                        </li>
                    </ul>
                </div>
                <div class="footer__column footer__mob-row">
                    <inline-svg src="/img/icons/master-card.svg" width="40" height="40" :fill="this.$store.state.nightMode ? 'white' : 'black'"></inline-svg>
                    <inline-svg src="/img/icons/visa.svg" width="45" height="45"></inline-svg>
                    <inline-svg src="/img/icons/liqpay.svg" width="80" height="26" :fill="this.$store.state.nightMode ? 'white' : 'black'"></inline-svg>
                    <inline-svg src="/img/icons/privat.svg" width="26" height="26"></inline-svg>
                </div>

                <div class="footer__column">
                    <div class="footer__row-title">
                        Завантажуй додаток:
                    </div>
                    <div class="footer__row">
                        <a href="https://apps.apple.com/cy/app/black-pizza/id1498371417" target="_blank" rel="nofollow" aria-label="App Store" onclick="dataLayer.push({'event': 'clickAppStore'});">
                            <img src="@/assets/appstore.webp" style="width: 120px; height: 38px" alt="App Store" title="App Store">
                        </a>

                        <a href="https://play.google.com/store/apps/details?id=com.oakmont.blackpizza" target="_blank" rel="nofollow" aria-label="Google Play" onclick="dataLayer.push({'event': 'clickGooglePlay'});">
                            <img src="@/assets/googleplay.webp" style="width: 120px; height: 38px" alt="Google Play" title="Google Play">
                        </a>
                    </div>
                    <div class="footer__row-title">
                        Слідкуй за нами:
                    </div>
                    <div class="footer__row">
                        <a href="https://youtube.com/@black_pizza" target="_blank" rel="nofollow" aria-label="Youtube">
                            <img src="@/assets/youtube-circle.svg" style="width: 40px;" alt="Youtube" title="Youtube">
                        </a>
                        <a href="https://www.instagram.com/black_pizza/" target="_blank" rel="nofollow" aria-label="Instagram">
                            <img src="@/assets/instagram-circle.svg" style="width: 40px;" alt="Instagram" title="Instagram">
                        </a>
                        <a href="https://www.tiktok.com/@pizza_black" target="_blank" rel="nofollow" aria-label="TikTok">
                            <img src="@/assets/tik-tok-cricle.svg" style="width: 40px;" alt="TikTok" title="TikTok">
                        </a>
                    </div>
                </div>
            </footer>
        </div>

        <div class="cart">
            <Cart/>
        </div>
    </div>
</template>

<script>
import Cart from '@/views/Cart.vue'
import InfoModal from '@/components/InfoModal.vue'
import LocationCityModal from '@/components/LocationCityModal.vue'
import Swiper from 'swiper'
import InlineSvg from 'vue-inline-svg';
import axios from 'axios'
import Product from "@/components/Product.vue";

export default {
    components: {
        Product,
        LocationCityModal,
        Cart,
        InfoModal,
        InlineSvg
    },
    data() {
        return {
            showInfoModal: false,
            isShowLocationCityModal: false,
            infoModalText: '',
            locationCities: [],
            isApplication: false,
            applicationType: '',
            applicationURL: '',
            categories: [],
            selectedLocationCity: {
                name: ''
            },
            mobNav: false
        }
    },

    methods: {
        mouseOverLeftMenu() {
            if (window.innerWidth <= 1024) {
                return;
            }
            let mainOverlay = this.$refs['main-overlay'];
            mainOverlay.style.display = 'block';
        },

        mouseLeaveLeftMenu() {
            let mainOverlay = this.$refs['main-overlay'];
            mainOverlay.style.display = 'none';
        },

        routerToRoute(name) {
            if(this.mobNav) {
                this.closeMobNav();
            }
            this.$router.push({name: name, params: {location_city: this.$route.params.locationCity}});
        },

        routerToCategoryRoute(name, code) {
            if(this.mobNav) {
                this.closeMobNav();
            }
            this.$router.push({name: name, params: {location_city: this.$route.params.locationCity, code: code}});
        },

        showInfomationModal(type) {
            this.isApplication = false;
            if (type == 'phone') {
                dataLayer.push({
                    'event': 'clickPhone'
                });
                this.infoModalText = 'Телефон: ' + this.$store.state.phone;
            }
            if (type == 'address') {
                this.infoModalText = 'адреса: <span style="font-weight: bold;">' + this.$store.state.address + '</span>';
            }
            if (type == 'time') {
                this.infoModalText = 'Графік роботи: <span style="font-weight: bold;">11:00-22:00</span>';
            }
            window.scrollTo(0, 0);
            document.querySelector('body').style.overflow = 'hidden';
            this.showInfoModal = true;
        },

        closeInfomationModal() {
            document.querySelector('body').style.overflow = '';
            this.showInfoModal = false;
        },

        changeMode() {
            let currentMode = JSON.parse(localStorage.getItem('nightmode')) || 0;
            let newMode = currentMode ? 0 : 1;
            localStorage.setItem('nightmode', newMode);
            this.$store.commit('setMode', newMode);

            if (newMode) {
                document.querySelector('body').style.backgroundColor = '#1c1a1a';
            } else {
                document.querySelector('body').style.backgroundColor = '';
            }
        },

        showLocationCityModal() {
            if(this.locationCities && this.locationCities.length > 1) {
                this.isShowLocationCityModal = true;
            }
        },

        closeLocationCityModal() {
            document.querySelector('body').style.overflow = '';
            this.isShowLocationCityModal = false;
        },

        changeLocationCity(locationCityId) {
            if(locationCityId != localStorage.getItem('locationCityId')) {
                localStorage.setItem('cart', JSON.stringify([]));
            }

            localStorage.setItem('locationCityId', locationCityId);
            this.$store.commit('setLocationCityId', locationCityId);

            if(locationCityId == 1) {
                window.location.replace('/lutsk');
            }
            else if(locationCityId == 2) {
                window.location.replace('/kyiv');
            }

            this.selectedLocationCity = this.$store.state.locationCities.filter(locationCity => {
                return locationCity.id == locationCityId
            });
            this.selectedLocationCity = this.selectedLocationCity.length > 0 ? this.selectedLocationCity[0] : this.$store.state.locationCities[0];

            let defaultLocation = this.selectedLocationCity.locations.filter(location => {
                return location.is_default == 1
            });

            defaultLocation = defaultLocation.length > 0 ? defaultLocation[0] : this.selectedLocationCity.locations[0];

            this.$store.commit('setPhone', this.selectedLocationCity.phone);
            this.$store.commit('setAddress', 'м. ' + this.selectedLocationCity.name + ', вул. ' + defaultLocation.name);
        },

        showMobNav() {
            this.mobNav = true;
        },

        closeMobNav() {
            document.querySelector('body').style.overflow = '';
            this.mobNav = false;
        },
    },

    beforeCreate() {
        let locationCityId = null;
        if(this.$route.params.locationCity == 'lutsk') {
            locationCityId = 1;
        }
        else if(this.$route.params.locationCity == 'kyiv') {
            locationCityId = 2;
        }

        localStorage.setItem('locationCityId', locationCityId);
        this.selectedLocationCity = locationCityId;
        this.$store.commit('setLocationCityId', locationCityId);
        this.$store.dispatch('getLocationCities').then(locationCities => {
            this.locationCities = locationCities;

            this.selectedLocationCity = this.$store.state.locationCities.filter(locationCity => {
                return locationCity.id == localStorage.getItem('locationCityId');
            });
            this.selectedLocationCity = this.selectedLocationCity.length > 0 ? this.selectedLocationCity[0] : this.$store.state.locationCities[0];

            let defaultLocation = this.selectedLocationCity.locations.filter(location => {
                return location.is_default == 1
            });

            defaultLocation = defaultLocation.length > 0 ? defaultLocation[0] : this.selectedLocationCity.locations[0];

            this.$store.commit('setPhone', this.selectedLocationCity.phone);
            this.$store.commit('setAddress', 'м. ' + this.selectedLocationCity.name + ', вул. ' + defaultLocation.name);
        });

        this.$store.dispatch('getCategories').then(categories => {
            this.categories = categories;
            console.log(this.categories);
        });
    },

    mounted() {
        axios.get(`https://api.pizza.black/api/${JSON.parse(localStorage.getItem('locationCityId'))}/settings`).then(response => {
            if (response.data.is_closed == 1 || response.data.is_closed_delivery == 1) {
                this.infoModalText = `${response.data.closed_title}<br>${response.data.closed_description}`;
                this.showInfoModal = true;
            } else {
                if ((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPad/i))) {
                    this.isApplication = true;
                    this.applicationType = 'ios';
                    this.applicationURL = 'https://apps.apple.com/cy/app/black-pizza/id1498371417';
                    this.showInfoModal = true;
                }

                if ((navigator.userAgent.match(/Android/i))) {
                    this.isApplication = true;
                    this.applicationType = 'android';
                    this.applicationURL = 'https://play.google.com/store/apps/details?id=com.oakmont.blackpizza';
                    this.showInfoModal = true;
                }
            }
        });

        if (this.$store.state.nightMode) {
            document.querySelector('body').style.backgroundColor = '#1c1a1a';
        }

        var mySwiper = new Swiper('.swiper-container', {
            // If we need pagination
            slidesPerView: 1,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },

            autoplay: {
                stopOnLastSlide: true
            },

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            // And if we need scrollbar
            scrollbar: {
                el: '.swiper-scrollbar',
            },
        });

        mySwiper.autoplay.start();
    }
}
</script>